import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { Endpoints } from "../../Global/Endpoints";
import CustomDropdown from "../../CustomControls/dropdownn";

import loginImage01 from "../../assets/images/registration/registration-steps-image-04.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-05.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-06.jpg";
import { useSelector } from "react-redux";
import ErrorModal from "../../Components/Security/ErrorModal";
import { useLocation } from 'react-router-dom';




const MinorScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
    const location = useLocation();
  debugger
   // Get values from navigation state if present
  const initialFname = location.state?.FirstName || "";
  const initialLname = location.state?.LastName || "";
  const initialDOB = location.state?.DOB? new Date(location.state.DOB) : null;
  const contractFromState = location.state?.Contract || "";
  const memberIdFromState = location.state?.MemberID || "";

  const [formData, setFormData] = useState({
    Fname: initialFname,
    Lname: initialLname,
    DOB: initialDOB,
    // Guardian's details
    GuardianFname: "",
    GuardianLname: "",
    GuardianDOB: null,
    TelePhn: "",
    Address: "",
    Emailid: "",
    Relation: "",
    MinorValidation: "N",
    Contract: contractFromState,
    MemberID: memberIdFromState,
  });

  const [errors, setErrors] = useState({});
  const relationshipOptions = [
    "Mother",
    "Father",
    "Legal Guardian"
  ];

  const validSSO = useSelector((state) => state.sso.isSSO); 
const ssoData = useSelector((state) => state.sso.ssoUserData); // Get full SSO user data
const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [logo, setLogo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [pendingNavigation, setPendingNavigation] = useState(false);

  useEffect(() => {

    const loadLogo = async () => {
      if (isHighmarkPortal) {
        const logoModule = await import("./../../assets/images/highmark/ffb-logo.jpg");
        setLogo(logoModule.default);
      } else {
        const logoModule = await import("./../../assets/images/win/logo-win.svg");
        setLogo(logoModule.default);
      }
    };

    loadLogo();
  }, [ssoData]);

  function formatToMMDDYYYY(date) {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d)) return "";
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
}
  
function getAge(date) {
  if (!date) return 0;
  const d = date instanceof Date ? date : new Date(date);
  const today = new Date();
  let age = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) {
    age--;
  }
  return age;
}




  const validateForm = () => {
    const newErrors = {};
    // Validate minor's details
    if (!formData.Fname) newErrors.Fname = "First name is required";
    if (!formData.Lname) newErrors.Lname = "Last name is required";
    if (!formData.DOB) newErrors.DOB = "Date of birth is required";
    
    // Validate guardian's details
    if (!formData.GuardianFname) newErrors.GuardianFname = "Parent/Guardian first name is required";
    if (!formData.GuardianLname) newErrors.GuardianLname = "Parent/Guardian last name is required";
    if (!formData.GuardianDOB) {
      newErrors.GuardianDOB = "Parent/Guardian date of birth is required";
     } else if (getAge(formData.GuardianDOB) < 18) {
    newErrors.GuardianDOB = "Parent/Guardian must be at least 18 years old";
  }
    if (!formData.TelePhn || formData.TelePhn.trim() === ""){ newErrors.TelePhn = "Phone number is required";
    }else if (!/^[\d\s()+-]{7,20}$/.test(formData.TelePhn.trim())) {
  newErrors.TelePhn = "Please enter a valid phone number";
}
    if (!formData.Address) newErrors.Address = "Address is required";
    if (!formData.Emailid) newErrors.Emailid = "Email address is required";
    else if (!/\S+@\S+\.\S+/.test(formData.Emailid)) {
      newErrors.Emailid = "Please enter a valid email address";
    }
    if (!formData.Relation) newErrors.Relation = "Relationship is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: ""
      }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      debugger
      // Format dates properly for the API
     // In handleSubmit:
const formattedDOB = formatToMMDDYYYY(formData.DOB);
const formattedGuardianDOB = formatToMMDDYYYY(formData.GuardianDOB);
        const params={Fname: formData.Fname,
          Lname: formData.Lname,
          DOB: formattedDOB,
          GuardianFname: formData.GuardianFname,
          GuardianLname: formData.GuardianLname,
          GuardianDOB: formattedGuardianDOB,
          TelePhn: formData.TelePhn,
          Address: formData.Address,
          Relation: formData.Relation,
          Emailid: formData.Emailid,
          Contract: formData.Contract,
          MemberID: formData.MemberID,
          MinorValidation: "N"}
      const response = await axios.post(
        Endpoints.SaveMinorAccessConsent,
        `_Params=${encodeURIComponent(JSON.stringify(
         params
        ))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }
      );
console.log("API Response minor acess:", response.data);
      if (response.data.result === 1) {
        setModalMessage("Details have been saved successfully. Please wait for your parent or guardian to approve the consent.");
        setShowModal(true);
        setPendingNavigation(true);
      } else {
        setModalMessage(response.data.resultText || "Failed to save minor access request");
        setShowModal(true);
        setPendingNavigation(false);
      }
    } catch (error) {
      console.error("Error saving minor access:", error);
      setModalMessage("An error occurred while processing your request");
      setShowModal(true);
      setPendingNavigation(false);
    }
  };

  useEffect(() => {
      const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
      
      if (myCarousel) {
          new window.bootstrap.Carousel(myCarousel, {
            interval: 5000, // Set interval in milliseconds
          });
        }
    }, []);

    const handleBackClick = () => {
      navigate(-1); // Redirects to the home page
};

 // Prevent manual typing in DatePicker
  const handleKeyDown = (e) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "Tab"
  ];
  const value = e.target.value;
  // Block input if already 10 characters
  if (value.length >= 10 && !allowedKeys.includes(e.key)) {
    e.preventDefault();
    return;
  }
  // Allow navigation + control keys
  if (allowedKeys.includes(e.key)) {
    return;
  }
  // Allow numbers
  if (/^[0-9]$/.test(e.key)) {
    return;
  }
  // Allow slash "/"
  if (e.key === "/") {
    return;
  }
  // Block everything else
  e.preventDefault();
};


// Modal close handler
  const handleModalClose = () => {
    setShowModal(false);
    if (pendingNavigation) {
      setPendingNavigation(false);
      navigate("/login");
    }
  };

  return (
    <>

    <header>
      <nav className="navbar navbar-expand-lg container-fixed">
        <a className="navbar-brand" href="#">
        {isHighmarkPortal ? 
          <img src={logo} alt="Logo" className="logo brand-logo" />
        : 
          <img src={logo} alt="Logo" className="logo brand-logo" />
        }            
        </a>
      </nav>
    </header>

    <div className="registration-block-main">

      {/* left carousel start */}
      <div className="registration-image-wrapper">
        <div
          id="carouselExampleSlidesOnly"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
              <img src={loginImage01} alt="" className="registration-image" />
            </div>
            <div className="carousel-item login-carousel-item" data-bs-interval="5000">
              <img src={loginImage02} alt="" className="registration-image" />
            </div>
            <div className="carousel-item login-carousel-item" data-bs-interval="5000">
              <img src={loginImage03} alt="" className="registration-image" />
            </div>
          </div>
        </div>
      </div>
      {/* left carousel end */}


      {/* registration right form area start */}
      <div className="registration-form-main">
        <div className="registration-form">
          <div className="registration-header">
            <h2 className="page-heading-bold text-center">{t("Minor Access")}</h2>
            <p className="subtext">
              We need your parent or guardian's consent for you to access the content in this app. Please
              enter their contact details below for us to send them a consent form.
            </p>
          </div>
          <div className="registration-process-form-wrapper mt-5">
          <form onSubmit={handleSubmit}>
            <div className="section-header">
              <h4 className="page-heading-secondary-black">{t("Create Account Details")}</h4>
            </div>
            
            <div className="form-group">
              <input
                type="text"
                name="Fname"
                value={formData.Fname}
                onChange={handleInputChange}
                placeholder={t("First Name")}
                className={`form-control win-form-control-x ${errors.Fname ? "is-invalid" : ""}`}
              readOnly
              />
              {errors.Fname && <div className="form-field-error-message">{errors.Fname}</div>}
            </div>

            <div className="form-group">
              <input
                type="text"
                name="Lname"
                value={formData.Lname}
                onChange={handleInputChange}
                placeholder={t("Last Name")}
                className={`form-control win-form-control-x ${errors.Lname ? "is-invalid" : ""}`}
              readOnly
              />
              {errors.Lname && <div className="form-field-error-message">{errors.Lname}</div>}
            </div>

            <div className="form-group">
              <DatePicker
                selected={formData.DOB}
                onChange={(date) => {
                  setFormData((prev) => ({ ...prev, DOB: date }));
                  if (errors.DOB) {
                    setErrors((prev) => ({ ...prev, DOB: "" }));
                  }
                }}
                placeholderText={t("Date of Birth")}
                className={`form-control win-form-control-x ${errors.DOB ? "is-invalid" : ""}`}
                maxDate={new Date()}
                showYearDropdown
                onKeyDown={(e) => e.preventDefault()}
                autoComplete="off"
             readOnly
             />
              {errors.DOB && <div className="form-field-error-message">{errors.DOB}</div>}
            </div>

            <div className="section-header mt-4">
              <h4 className="page-heading-secondary-black">{t("Parent/Guardian Details")}</h4>
            </div>

            <div className="form-group">
              <input
                type="text"
                name="GuardianFname"
                value={formData.GuardianFname}
                onChange={handleInputChange}
                placeholder={t("Parent/Guardian First Name")}
                className={`form-control win-form-control-x ${errors.GuardianFname ? "is-invalid" : ""}`}
              maxLength={50}
              />
              {errors.GuardianFname && <div className="form-field-error-message">{errors.GuardianFname}</div>}
            </div>

            <div className="form-group">
              <input
                type="text"
                name="GuardianLname"
                value={formData.GuardianLname}
                onChange={handleInputChange}
                placeholder={t("Parent/Guardian Last Name")}
                className={`form-control win-form-control-x ${errors.GuardianLname ? "is-invalid" : ""}`}
              maxLength={50}
              />
              {errors.GuardianLname && <div className="form-field-error-message">{errors.GuardianLname}</div>}
            </div>

            <div className="form-group">
              <DatePicker
  selected={formData.GuardianDOB}
  onChange={(date) => {
    setFormData((prev) => ({ ...prev, GuardianDOB: date }));
    if (errors.GuardianDOB) {
      setErrors((prev) => ({ ...prev, GuardianDOB: "" }));
    }
  }}
  placeholderText={t("Parent/Guardian Date of Birth")}
  className={`form-control win-form-control-x ${errors.GuardianDOB ? "is-invalid" : ""}`}
  maxDate={new Date()}
  showYearDropdown
  scrollableYearDropdown
  yearDropdownItemNumber={100}
  onKeyDown={handleKeyDown}
  //onKeyDown={(e) => e.preventDefault()}
  autoComplete="off"
/>
              {errors.GuardianDOB && <div className="form-field-error-message">{errors.GuardianDOB}</div>}
            </div>

            <div className="form-group">
              <input
                type="tel"
                name="TelePhn"
                value={formData.TelePhn}
                onChange={handleInputChange}
                placeholder={t("Telephone Number")}
                className={`form-control win-form-control-x ${errors.TelePhn ? "is-invalid" : ""}`}
                maxLength={20}
              />
              {errors.TelePhn && <div className="form-field-error-message">{errors.TelePhn}</div>}
            </div>

            <div className="form-group">
              <input
                type="text"
                name="Address"
                value={formData.Address}
                onChange={handleInputChange}
                placeholder={t("Address")}
                className={`form-control win-form-control-x ${errors.Address ? "is-invalid" : ""}`}
               maxLength={50}
              />
              {errors.Address && <div className="form-field-error-message">{errors.Address}</div>}
            </div>

            <div className="form-group">
              <input
                type="email"
                name="Emailid"
                value={formData.Emailid}
                onChange={handleInputChange}
                placeholder={t("Email Address")}
                className={`form-control win-form-control-x ${errors.Emailid ? "is-invalid" : ""}`}
               maxLength={50}
              />
              {errors.Emailid && <div className="form-field-error-message">{errors.Emailid}</div>}
            </div>

            <div className="form-group">
              <CustomDropdown
                options={relationshipOptions}
                selectedOption={formData.Relation}
                onChange={(option) => {
                  setFormData((prev) => ({ ...prev, Relation: option }));
                  if (errors.Relation) {
                    setErrors((prev) => ({ ...prev, Relation: "" }));
                  }
                }}
                placeholder={t("Relationship")}
                searchable={true}
                className={`form-control win-form-control ${errors.Relation ? "is-invalid" : ""}`}
              />
              {errors.Relation && <div className="form-field-error-message">{errors.Relation}</div>}
            </div>

            <div className="registration-process-form-wrapper mt-5">
     <button className="win-btn-secondary mobile-view mt-2 mb-3 me-3" onClick={handleBackClick}>Back</button>
<button className="win-btn-primary mobile-view mt-2 mb-3">{t("Submit")} </button>
</div>
          </form>
          </div>
        </div>
      </div>
      <ErrorModal
          show={showModal}
          message={modalMessage}
          onClose={handleModalClose}
          closeButton={true}
        />
    </div>
    </>
  );
};

export default MinorScreen;